import script from "./MallCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./MallCategories.vue?vue&type=script&setup=true&lang=js"

import "./MallCategories.vue?vue&type=style&index=0&id=7542f8a9&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7542f8a9"]])

export default __exports__